import "./sentry";
import "./lib/i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import { preventIosInputZoom } from "./utils/preventIosInputZoom";

preventIosInputZoom();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
